import { useState } from "react";
import MemberCard from "./MemberCard/MemberCard";
import { useTeamContext } from "store/contexts/teamContext";
import Scrollbar from "react-scrollbars-custom";
import { useUserContext } from "store/contexts/userContext";

export default () => {
  const { team } = useTeamContext();
  const { user } = useUserContext();
  const [teamMembers] = useState(getYourData);
  const root = {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fill, 254px)",
    gridGap: "10px",
    padding: "12px 20px 0px 20px",
  };

  function getYourData() {
    var allTeamMember = team?.members.sort((a, b) => a.role_id - b.role_id);

    var userData = team?.members.filter((member) => {
      return member?.id === user.id;
    });

    let memberIndex = team?.members.indexOf(userData[0]);
    allTeamMember.splice(memberIndex, 1);
    allTeamMember.splice(0, 0, userData[0]);
    return allTeamMember;
  }

  return (
    <div className="row teaminfo-users mt-30">
      <Scrollbar>
        <div style={root}>
          {teamMembers.map((member) => (
            <MemberCard member={member} key={member.id} />
          ))}
        </div>
      </Scrollbar>
    </div>
  );
};
